<script lang="ts">
  import { Router, type RouteConfig } from '@mateothegreat/svelte5-router';
  import Toasts from './components/Toasts.svelte';
  import './global.css';
  import PresenterView from './pages/PresenterView.svelte';
  import Root from './pages/Root.svelte';

  const routes: RouteConfig[] = [
    {
      name: 'root',
      component: Root,
    },
    {
      name: 'presenter',
      path: 'presenter',
      component: PresenterView,
    },
  ];
</script>

<Toasts />
<Router {routes} />
